import React from 'react';
import styles from './RevenueCard.module.css';

export const RevenueCard: React.FC = () => {
  return (
    <div className={styles.card}>
      <span className={styles.iconCircle}>$</span>
      <div className={styles.body}>
        <p className={styles.label}>Potential Additional Revenue</p>
        <p className={styles.value}>$3,400</p>
        <p className={styles.note}>This Month if all acted upon</p>
      </div>
    </div>
  );
};
